import * as ccp from '@/api/modules/ccp';
import { Api, Spectra, SpectraModule } from '@/decorators';

@Spectra({ namespaced: true, name: 'Ccp' })
export default class extends SpectraModule {
  @Api() ccpGameList = ccp.postCcpGameList;
  @Api() ccpGameRegistration = ccp.postCcpGameRegistration;
  @Api() ccpGameDetail = ccp.postCcpGameDetail;
  @Api() ccpGameDeclaration = ccp.postCcpGameUpdateDeclaration;
  @Api() ccpGameRankTop = ccp.postCcpGameRankTop;
  @Api() ccpGameRankAll = ccp.postCcpGameRankAll;
  @Api() ccpGameInfo = ccp.postCcpGameInfo;
  @Api() ccpProblemAnswerInformation = ccp.postCcpProblemAnswerInformation;
  @Api() submissionLatest = ccp.postCcpProblemSubmissionLatest;
  @Api() problemSubmissionList = ccp.postCcpProblemSubmissionList;
  @Api() ccpProblemRun = ccp.postCcpProblemRun;
  @Api() ccpProblemCodeSave = ccp.postCcpProblemCodeSave;
  @Api() ccpProblemSubmissionRun = ccp.postCcpProblemSubmissionRun;
  @Api() gameDone = ccp.postCcpGameDone;
  @Api() chatHistoryList = ccp.postCcpProblemChatHistoryList;
  @Api() chatDetail = ccp.postCcpProblemChatDetail;
  @Api() modelScore = ccp.postCcpProblemModelScore;
}
